var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback } from 'react';
import { useModal } from '@lucidlink/uicore';
import { FILESPACE_QUIT_RETRY_COUNT, MODAL_IDS } from '#constants';
import { DEPENDENCY_KEYS, useDependency } from '#context';
import { useOnFilespaceUpgrade } from '#hooks';
const UPGRADE_DISCONNECT = 'upgradeDisconnect';
export const useFilespaceUpgradeDisconnect = ({ currentMember, filespaceList, workspaceId, }) => {
    _react_refresh_temp_1();
    const { mutation: { mutate: filespaceQuit }, } = useDependency(DEPENDENCY_KEYS.UseFilespaceQuit)(FILESPACE_QUIT_RETRY_COUNT);
    const { closeModal } = useModal({
        modalId: MODAL_IDS.FilespaceDetails,
    });
    const onStartUpgrade = useCallback(({ filespace: currentFilespace }) => {
        filespaceQuit({
            filespaceId: currentFilespace.id,
            workspaceId: currentFilespace.workspaceId,
            filespaceName: currentFilespace.name,
            noToast: true,
        });
    }, [filespaceQuit]);
    const onFinishUpgrade = useCallback(({ isUpgradeSuccessful }) => {
        if (isUpgradeSuccessful) {
            closeModal();
        }
    }, [closeModal]);
    useOnFilespaceUpgrade({
        filespaceList,
        onFinishUpgrade,
        onStartUpgrade,
        localStorageKey: currentMember?.id
            ? `${UPGRADE_DISCONNECT}-${workspaceId}-${currentMember.id}`
            : undefined,
    });
};
_react_refresh_temp_1(useFilespaceUpgradeDisconnect, "Qauyz9a8PBEPbLg1WW9NxTxXb6k=", false, () => [useDependency, useModal, useOnFilespaceUpgrade]);
